export const BILLING_STATUSES = [
  {
    name: 'SUBMITTED',
    value: 'SUBMITTED',
  },
  {
    name: 'NEED APPROVE',
    value: 'NEED_APPROVE',
  },
  {
    name: 'APPROVED',
    value: 'APPROVED',
  },
  {
    name: 'REJECTED',
    value: 'REJECTED',
  },
];

export const DETECTION_REQUEST_STATUS = [
  {
    label: 'PENDING',
    value: 'PENDING',
  },
  {
    label: 'APPROVED',
    value: 'APPROVED',
  },
  {
    label: 'REJECTED',
    value: 'REJECTED',
  },
  {
    label: 'UPDATED',
    value: 'UPDATED',
  },
];

export const STATUS_REDACT_CUSTOMER_DATA = [
  {
    label: 'CREATED',
    value: 'CREATED',
  },
  {
    label: 'PROCESSING',
    value: 'PROCESSING',
  },
  {
    label: 'COMPLETED',
    value: 'COMPLETED',
  },
];
